import React, { Component } from 'react'
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Divider, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { PopUpForm } from '../../../lib/ui/popupform';
import { formatMoney } from '../../../lib/util';


const fetcher_cols = ({onEditPressed}) => [
    {
        title: "Fetcher Name",
        dataIndex: "name",
        key: 'name'
    },
    {
        title: "Version",
        dataIndex: 'version',
        key: 'version'
    },
    {
        title: "ID",
        dataIndex: 'id',
        key: 'id'
    },
]


class FetcherView extends Component {
    constructor(props) {
        super(props)

        this.state = {
        };
        this.list_fetchers = RESTExecutor.list().config({
            label: 'fetchers',
        }).connect(props.domains.settings);

        console.log("constructed")
    };



    render() {

        let list_fetchers_res = this.list_fetchers.response();
        let list_fetchers_data = list_fetchers_res.result || {};

        let rowsMeta=list_fetchers_res.meta||{};
        let rowsData = list_fetchers_data.rows || [];
        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }

        return (
            <div>
                <Table
                loading={list_fetchers_res.fetching}
                scroll={{x:true}}
                    columns={fetcher_cols({
                    })}
                    dataSource={filteredData}
                    className='main-table  '
                    size='small'
                    
                    pagination={{
                        showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Fetcher List</Title>
                        {/* <Button type='primary' onClick={() => {
                            this.setState({
                                edit_id: null,
                                form_data: {},
                                form_visibility: true
                            })
                        }}>Add New Fetcher</Button> */}
                    </Row>
                    <br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                        }}
                        autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row>
                    </div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

    componentDidMount() {
        this.list_fetchers.execute()
    }
}

export default withDomains(FetcherView, "settings")
